/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class PageHeading extends Component {
  // passed in
  label = null;

  title = null;
  icon = null;
}
